import {
  CREATEFORECAST,
  GETFORECAST,
  DELETEFORECAST,
  UPDATEFORECAST,
  GETALLCONTACTCAMPAIGN,
  CREATE_CONTACT_CAMPAIGN,
  UPDATE_CONTACT_CAMPAIGN,
  DELETE_CONTACT_CAMPAIGN,
} from "../actions/types";

const initialState = {
  contactCampaignList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETFORECAST:
      return {
        ...state,
        forecastList: action.payload.data,
      };
    case UPDATEFORECAST:
      return {
        ...state,
        forecastUpdateStatus: action.payload.success,
      };

    case DELETEFORECAST:
      return {
        ...state,
        forecastList: state.forecastList.filter(
          (item) => item.id !== action.id,
        ),
        forecastDeleteStatus: action.payload.success,
      };

    case GETALLCONTACTCAMPAIGN:
      return {
        ...state,
        contactCampaignList: action.payload.data,
      };
    case CREATE_CONTACT_CAMPAIGN:
      return {
        ...state,
        contactCampaignSaveStatus: action.payload.success,
      };

    case UPDATE_CONTACT_CAMPAIGN:
      return {
        ...state,
        contactCampaignUpdateStatus: action.payload.success,
      };

    case DELETE_CONTACT_CAMPAIGN:
      return {
        ...state,
        contactCampaignList: state.contactCampaignList.filter(
          (item) => item.id !== action.id,
        ),
        contactCampaignDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
